import React from "react";

const getIconClass = (type: string) => {
  const lowerType = type.toLowerCase();

  if (lowerType.includes("historical")) {
    return "far fa-landmark";
  } else if (lowerType.includes("museum")) {
    return "far fa-monument";
  } else if (lowerType.includes("adventure")) {
    return "far fa-hiking";
  } else if (lowerType.includes("food")) {
    return "far fa-utensils";
  } else if (lowerType.includes("nature")) {
    return "far fa-tree";
  } else if (lowerType.includes("art")) {
    return "far fa-palette";
  } else if (lowerType.includes("music")) {
    return "far fa-music";
  } else if (lowerType.includes("shopping")) {
    return "far fa-shopping-bag";
  } else if (lowerType.includes("beach")) {
    return "far fa-umbrella-beach";
  } else if (lowerType.includes("award")) {
    return "far fa-trophy";
  } else if (lowerType.includes("audio")) {
    return "far fa-headphones";
  } else if (lowerType.includes("bus")) {
    return "far fa-bus-simple";
  } else if (lowerType.includes("city")) {
    return "far fa-building";
  } else if (lowerType.includes("luxury")) {
    return "far fa-crown";
  } else if (lowerType.includes("cruises")) {
    return "far fa-ship";
  } else if (lowerType.includes("best")) {
    return "far fa-star";
  } else if (lowerType.includes("walking")) {
    return "far fa-shoe-prints";
  } else if (lowerType.includes("skip")) {
    return "far fa-forward";
  } else if (lowerType.includes("disney")) {
    return "far fa-ferris-wheel";
  } else if (lowerType.includes("full")) {
    return "far fa-clock-rotate-left";
  } else if (lowerType.includes("memorial")) {
    return "far fa-landmark-flag";
  } else if (lowerType.includes("bike")) {
    return "far fa-bicycle";
  } else {
    return "far fa-globe"; // Default icon
  }
};

interface ProductTypesProps {
  product: any;
}

const ProductTypes: React.FC<ProductTypesProps> = ({ product }) => {
  return (
    <div className="w-full flex flex-row items-center justify-start space-x-3 rounded-full my-2 overflow-x-scroll no-scrollbar whitespace-nowrap">
      {product?.types.slice(0, 3).map((type: string, index: number) => (
        <div
          key={index}
          className="flex-none flex flex-row items-center space-x-2 bg-neutral-100 rounded-full px-3 py-2"
        >
          <i className={`${getIconClass(type)} text-neutral-700 text-xs`}></i>
          <p className="text-neutral-700 font-light text-xs leading-relaxed whitespace-nowrap">
            {type}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProductTypes;
